import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import AppLayout from '../layouts/AppLayout.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'bienvenida' },
  },
  {
    name: 'encuestas',
    path: '/encuestas',
    component: AppLayout,
    redirect: { name: 'organizador' },
    children: [
      {
        name: 'organizador',
        path: 'organizador',
        component: () => import('../modules/organizer/ProjectsPage.vue'),
      },
      {
        name: 'restaurante',
        path: 'restaurante',
        component: () => import('../modules/restaurant/ProjectsPage.vue'),
      },
      {
        name: 'asistente',
        path: 'asistente',
        component: () => import('../modules/attendance/ProjectsPage.vue'),
      },

      {
        name: 'alojamiento',
        path: 'alojamiento',
        component: () => import('../modules/accommodation/ProjectsPage.vue'),
      },

      {
        name: 'agradecimiento',
        path: 'agradecimiento',
        component: () => import('../modules/gratitude/ProjectsPage.vue'),
      },

      {
        name: 'bienvenida',
        path: 'bienvenida',
        component: () => import('../modules/welcome/ProjectsPage.vue'),
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

export default router
